import React, { useState, useEffect } from "react";
import { getAboutData } from "../firestoreServices"; // تأكد من المسار

const About = ({ lang }) => {
  const [dbData, setDbData] = useState(null);

  // المحتوى الافتراضي (نفس اللي كان عندك)
  const defaultContent = {
    imageUrl:
      "https://res.cloudinary.com/defcamc5x/image/upload/v1766847982/vausdwudo0bxewmpcshx.png",
    ar: {
      title: "عن المكتب",
      heading: "الريادة في الحلول القانونية المتخصصة",
      description:
        " الوكيل شركة محاماة متخصصة تقدم إستشارات قانونية في التوقيت المناسب، وتمثل العملاء أمام جميع المحاكم.",
      mission:
        "تلتزم الشركة بدعم العملاء للعمل بثقة وأمان في إطار قانوني صحيح داخل المشهد القانوني المتطور.",
    },
    en: {
      title: "About Us",
      heading: "Pioneering Specialized Legal Solutions",
      description:
        "El-Wakil Law Firm is a specialized practice providing timely legal advice and representing clients before all courts.",
      mission:
        "We are committed to supporting clients to operate with confidence and security within a sound legal framework in the evolving legal landscape.",
    },
  };

  useEffect(() => {
    getAboutData().then((data) => {
      if (data) setDbData(data);
    });
  }, []);

  const content = dbData || defaultContent;
  const t = content[lang] || defaultContent[lang];
  const isAr = lang === "ar";
  // التأكد من وجود الصورة، لو مفيش نستخدم الافتراضية
  const displayImage = content.imageUrl || defaultContent.imageUrl;

  return (
    <section className="about-section" id="about" dir={isAr ? "rtl" : "ltr"}>
      <div className="container">
        <div className="about-content">
          {/* الصورة */}
          <div className="about-image-wrapper">
            <img
              src={displayImage}
              alt="About El-Wakil Firm"
              className="about-image"
            />
            <div className="image-frame"></div>
          </div>

          {/* النص */}
          <div className="about-text">
            <h4 className="section-subtitle">{t.title}</h4>
            <div className="gold-divider"></div>
            {/* عرضنا العنوان لو موجود في الداتا بيز */}
            {t.heading && <h3 className="about-heading">{t.heading}</h3>}
            <p className="about-desc">{t.description}</p>
            <p className="about-desc">{t.mission}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
